import { useEffect, useState } from "react";
import { FormDataConsumer, Create, SimpleForm, useStore } from "react-admin";
import { Grid, Typography } from "@mui/material";

import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

import PersonalInfo from "./Partials/PersonalInfo";
import CandidacyInfo from "./Partials/CandidacyInfo";
import { useLocation } from "react-router";
import BackButtonToolbar from "features/BackButtonToolbar";
import { CampaignSubTypes } from "utils/constants";

const CreateIntermediaryCandidacy = ({ title }) => {
  const [selectedSpecialityIds, setSelectedSpecialityIds] = useState([]);
  const [schoolSubjectsGrades, setSchoolSubjectGrades] = useState([]);

  // Read-only consumer of the committed campaign from the regular candidates list.
  const [filters] = useStore(`campaign-query-subtype-${CampaignSubTypes.Regular}`, null);
  const campaignId = filters?.campaignId ?? null;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type");

  const transform = data => {
    if (data) {
      data.info.citizenshipId = type === "Es" ? 2 : 3;
    }
    return {
      ...data,
      info: {
        ...data.info,

        secondName: data.info.secondName || "",
        secondNameEn: data.info.secondNameEn || "",
      },
      campaignId: Number(campaignId),
      schoolSubjectsGrades: schoolSubjectsGrades,
    };
  };

  const handleSelectedSpecialityIds = data => {
    setSelectedSpecialityIds(data.map(p => p.specialityId));
  };

  return (
    <SecuredComponent permission={permissions.canCreateCandidacy}>
      <Create
        title={`Създаване на кандидатура на чужденец ${type === "Es" ? "ЕС" : "извън ЕС"} за кампания - ${title} `}
        transform={transform}
        actions={<BackButtonToolbar />}
      >
        <SimpleForm defaultValues={{ regular: true, participatesInRanking: true }}>
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{ margin: "0 auto 4rem " }}
                >
                  <Typography color={"primary"}>Данни за кандидата</Typography>
                </Grid>

                <PersonalInfo
                  formData={formData}
                  isForeigner={true}
                />
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{ margin: "0 auto 4rem" }}
                >
                  <Typography color={"primary"}>Данни за кандидатурата</Typography>
                </Grid>
                <CandidacyInfo
                  isForeigner={true}
                  formData={formData}
                  selectedSpecialityIds={selectedSpecialityIds}
                  setSelectedSpecialityIds={setSelectedSpecialityIds}
                  handleSelectedSpecialityIds={handleSelectedSpecialityIds}
                  campaignId={campaignId}
                  setSchoolSubjectGrades={setSchoolSubjectGrades}
                />
              </>
            )}
          </FormDataConsumer>
        </SimpleForm>
      </Create>
    </SecuredComponent>
  );
};
export default CreateIntermediaryCandidacy;
